const productList = [

    {
        id: 1,
        type: 1,
        title: 'CODcr在线自动监测仪',
        value: 'XRP-CODcr-1801',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/CODcr在线自动监测仪.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/CODcr在线自动监测仪侧.png',//内部
        clfb: '依据标准HJ377-2019《水质-化学耗氧量测定-重铬酸盐法》',
        cxcc: '0-200 mg/L;0-500mg/L;0-1000mg/L; 量程可定制',
        dy: '（(220 V±22)V/AC,      (50±0.5Hz),5A,150Ws',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 2,
        type: 1,
        title: '氨氮在线自动监测仪',
        value: 'XRP-NH4N-1802',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/氨氮在线自动监测仪.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/氨氮在线自动监测仪侧.png',
        clfb: 'HJ536-2009水质 氨氮-水杨酸分光光度法（可定制纳氏方法）',
        cxcc: '0-2 mg/L;0-10 mg/L;0-50mg/L; 量程可定制',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '化工',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '化工',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶金',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '制药',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '化工',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '农业',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '冶金',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '制药',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '化工',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 3,
        type: 1,
        title: '总磷（TP）在线自动监测仪',
        value: 'XRP-TP-1803',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/总磷在线自动监测仪.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/总磷在线自动监测仪侧.png',
        clfb: '钼酸铵分光光度法 (HJ/T  103-2003)',
        cxcc: '0-2 mg/L;0-10mg/L;0-50mg/L;  量程可定制',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 4,
        type: 1,
        title: '总氮（TN）在线自动监测仪',
        value: 'XRP-TN-1804',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/总氮（TN）在线自动监测仪.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/总氮（TN）在线自动监测仪侧.png',
        clfb: '碱性过硫酸钾消解紫外分光光度法 (HJ/T  103-2003)',
        cxcc: '0-5 mg/L;0-20mg/L;0-50mg/L; 量程可定制',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm; 下机柜700*450*300mm',
        cgAlList: [
           
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 5,
        type: 1,
        title: '高锰酸盐指数（CODMn）在线自动监测仪',
        value: 'XRP-CONMN-1805',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/高锰酸盐指数(CODmn)在线自动监测仪.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/高锰酸盐指数(CODmn)在线自动监测仪侧.png',
        clfb: '高锰酸钾氧化滴定法',
        cxcc: '0-20mg/L;0-50mg/L; 量程可定制',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 6,
        type: 1,
        title: '六价铬（Cr6+）在线自动监测仪',
        value: 'XRP-Cr6+-1807',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/六价铬（Cr6+）在线自动监测仪.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/六价铬（Cr6+）在线自动监测仪侧.png',
        clfb: '二苯碳酰二肼分光光度比色法',
        cxcc: '0-2 mg/L;0-20mg/L;  量程可定制',
        dy: '(220V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
           
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 7,
        type: 1,
        title: '总铬（TCr）在线自动监测仪',
        value: 'XRP-TCr-1808',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/总铬（TCr）在线自动监测仪.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/总铬（TCr）在线自动监测仪侧.png',
        clfb: '二苯碳酰二肼分光光度比色法',
        cxcc: '0-2 mg/L;0-20mg/L;量程可定制',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm; 下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 8,
        type: 1,
        title: '总镍（TNi）在线自动监测仪',
        value: 'XRP-TNi-1809',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/TNi总镍.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/TNi总镍侧.png',
        clfb: '二苯碳酰二肼分光光度比色法',
        cxcc: '0-2 mg/L;0-20mg/L; 量程可定制',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm; 下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 9,
        type: 1,
        title: '总铜（TCu）在线自动监测仪',
        value: 'XRP-TCu-1810',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/TCu总铜.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/TCu总铜侧.png',
        clfb: '二乙基二硫代氨基甲酸钠分光光度法',
        cxcc: '0-2 mg/L;0-20mg/L;  量程可定制',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
           
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 10,
        type: 1,
        title: '总锰（TMn）在线自动监测仪',
        value: 'XRP-TMn-1811',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/TMn总锰.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/TMn总锰侧.png',
        clfb: '分光光度法',
        cxcc: '0-15mg/L',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 11,
        type: 1,
        title: '总铁（TFe）在线自动监测仪',
        value: 'XRP-TFe-1812',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/TFe总铁.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/TFe总铁侧.png',
        clfb: '分光光度法',
        cxcc: '0-10mg/L',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 12,
        type: 1,
        title: '总铅（TPb）在线自动监测仪',
        value: 'XRP-TPb-1813',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/TPb总铅.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/TPb总铅侧.png',
        clfb: '分光光度法',
        cxcc: '0-5mg/L',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 13,
        type: 1,
        title: '总锌（TZn）在线自动监测仪',
        value: 'XRP-TZn-1814',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/TZn总锌.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/TZn总锌侧.png',
        clfb: '分光光度法',
        cxcc: '0-10 mg/L',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 14,
        type: 1,
        title: '总砷（TAs）在线自动监测仪',
        value: 'XRP-TAs-1815',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/TAs总砷.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/TAs总砷侧.png',
        clfb: '分光光度法',
        cxcc: '0-2 mg/L',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm;下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 15,
        type: 1,
        title: '总汞（THg）在线自动监测仪',
        value: 'XRP-THg-1816',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/THg总汞.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/THg总汞侧.png',
        clfb: '分光光度法',
        cxcc: '0-1 mg/L',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm; 下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 16,
        type: 1,
        title: '总银（TAg）在线自动监测仪',
        value: 'XRP-TAg-1817',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/TAg总银.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/TAg总银侧.png',
        clfb: '分光光度法',
        cxcc: '0-5 mg/L',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm; 下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 17,
        type: 1,
        title: '总镉（TCd）在线自动监测仪',
        value: 'XRP-TCd-1818',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/TCd总镉.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/TCd总镉侧.png',
        clfb: '分光光度法',
        cxcc: '0-1 mg/L',
        dy: '(220 V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm; 下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 18,
        type: 1,
        title: '氰化物（CN）在线自动监测仪',
        value: 'XRP-CN-1821',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/CN氰化物.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/CN氰化物侧.png',
        clfb: '分光光度法',
        cxcc: '0-0.5mg/L',
        dy: '(220V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm; 下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 19,
        type: 1,
        title: '氟化物(FU)在线自动监测仪',
        value: 'XRP-FU-1820',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/Fu氟化物.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/Fu氟化物侧.png',
        clfb: '分光光度法',
        cxcc: '0-10 mg/L',
        dy: '(220V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 20,
        type: 1,
        title: '挥发酚(VP)在线自动监测仪',
        value: 'XRP-VP-1822',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/VP挥发酚.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/VP挥发酚侧.png',
        clfb: '分光光度法',
        cxcc: '0-10 mg/I',
        dy: '(220V±22)V/AC,(50±0.5Hz),5A,150W',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 21,
        type: 1,
        title: '水质在线监测岸边站(微型站)',
        value: 'XRP-200',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/微型多参数水质监测站.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/微型多参数水质监测站.png',
        clfb: '化学法+光学法+离子选择法',
        cxcc: '符合国标',
        dy: '（220V±22）V/AC',
        gz: '长1600*宽1250*高1800，长800*宽600*高1800',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },  
    {
        id: 22,
        type: 1,
        title: '水质在线监测岸边站(微型站)',
        value: 'XRP-201',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/微型多参数水质监测站2.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/微型多参数水质监测站2.png',
        clfb: '化学法+光学法+离子选择法',
        cxcc: '符合国标',
        dy: '（220V±22）V/AC',
        gz: '长1600*宽1250*高1800，长800*宽600*高1800',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 23,
        type: 1,
        title: '水质采样器',
        value: 'XRP-202',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/采样器.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/采样器侧.png',
        clfb: '分光光度法',
        cxcc: '符合国标',
        dy: '（220V±22）V/AC',
        gz: '上机柜600*450*300mm;  下机柜700*450*300mm',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 24,
        type: 3,
        title: '数据采集传输仪',
        value: 'XRP-1850',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/数据采集传输仪.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/A数据采集传输仪.png',
        clfb: '数据采集',
        cxcc: '320*380*80(mm（W×D×H）',
        dy: 'DC18V-36V',
        gz: '(50±0.5Hz)',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 25,
        type: 3,
        title: '电导率',
        value: 'XRP',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/电导率.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/电导率.png',
        clfb: '数据采集',
        cxcc: '320*380*80(mm（W×D×H）',
        dy: 'DC18V-36V',
        gz: '(50±0.5Hz)',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 26,
        type: 3,
        title: '电导率',
        value: 'XRP',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/电导率.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/电导率.png',
        clfb: '数据采集',
        cxcc: '320*380*80(mm（W×D×H）',
        dy: 'DC18V-36V',
        gz: '(50±0.5Hz)',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 27,
        type: 3,
        title: '溶氧',
        value: 'XRP',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/溶氧.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/溶氧.png',
        clfb: '数据采集',
        cxcc: '320*380*80(mm（W×D×H）',
        dy: 'DC18V-36V',
        gz: '(50±0.5Hz)',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 28,
        type: 3,
        title: '污泥界面仪',
        value: 'XRP',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/污泥界面仪.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/污泥界面仪.png',
        clfb: '数据采集',
        cxcc: '320*380*80(mm（W×D×H）',
        dy: 'DC18V-36V',
        gz: '(50±0.5Hz)',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 29,
        type: 3,
        title: '污泥浓度',
        value: 'XRP',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/污泥浓度.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/污泥浓度.png',
        clfb: '数据采集',
        cxcc: '320*380*80(mm（W×D×H）',
        dy: 'DC18V-36V',
        gz: '(50±0.5Hz)',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 30,
        type: 3,
        title: '悬浮物',
        value: 'XRP',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/悬浮物.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/悬浮物.png',
        clfb: '数据采集',
        cxcc: '320*380*80(mm（W×D×H）',
        dy: 'DC18V-36V',
        gz: '(50±0.5Hz)',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 31,
        type: 3,
        title: '液位计',
        value: 'XRP',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/液位计.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/液位计.png',
        clfb: '数据采集',
        cxcc: '320*380*80(mm（W×D×H）',
        dy: 'DC18V-36V',
        gz: '(50±0.5Hz)',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 32,
        type: 3,
        title: '浊度',
        value: 'XRP',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/浊度.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/浊度.png',
        clfb: '数据采集',
        cxcc: '320*380*80(mm（W×D×H）',
        dy: 'DC18V-36V',
        gz: '(50±0.5Hz)',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 33,
        type: 3,
        title: 'PH-ORP',
        value: 'XRP',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/PH-ORP.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/PH-ORP.png',
        clfb: '数据采集',
        cxcc: '320*380*80(mm（W×D×H）',
        dy: 'DC18V-36V',
        gz: '(50±0.5Hz)',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 34,
        type: 3,
        title: '五参数分析仪',
        value: 'XRP',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/五参数分析仪.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/五参数分析仪.png',
        clfb: '数据采集',
        cxcc: '320*380*80(mm（W×D×H）',
        dy: 'DC18V-36V',
        gz: '(50±0.5Hz)',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    {
        id: 35,
        type: 3,
        title: '流量计',
        value: 'XRP',
        src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/超声波明渠流量计.png',
        src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/超声波明渠流量计.png',
        clfb: '量水堰槽把明渠内流量的大小转成液位的高低。仪表测量量水堰槽内的水位，再按相应量水堰槽的水位一流量关系反算出流量',
        cxcc: '0.3~2m(根据高度换算成流量)或根据要求扩展',
        dy: 'AC85~265V±10%  或9~36VDC',
        gz: '320*380*80(mm（W×D×H）',
        cgAlList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
                name: '化工',

            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
                name: '能源',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
                name: '酿造',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
                name: '农业',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
                name: '食品',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
                name: '水利',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
                name: '冶炼',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
                name: '印刷',
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
                name: '制药',
            },
        ],
        ysList: [
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
                name: '报警功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
                name: '反控功能',
                title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
                name: '反控功能',
                title: "运行过程中发生异常系统自动报警",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '掉电恢复后自动工作',
                title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '整点、间隔和外部控制测量',
                title: "实时监测、留样、分析数据，高效安全",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
                name: '故障和缺试剂提示',
                title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
            },
            {
                imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
                name: '自动清洗功能',
                title: " 自动清洗、一键式清洗",
            },
        ],
    },
    // {
    //     id: 29,
    //     type: 3,
    //     title: '悬浮物在线监测系统',
    //     value: 'FX',
    //     src: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/悬浮物在线监测系统.png',
    //     src1: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/悬浮物在线监测系统.png',
    //     clfb: '带自动清洗功能，清洗刮片与传感器一体式不需要外围元件',
    //     cxcc: '146*146*80(mm（W×D×H）',
    //     dy: '（220V±22）V/AC',
    //     gz: '(50±0.5Hz)',
    //     cgAlList: [
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/化工.svg',
    //             name: '化工',

    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/能源.svg',
    //             name: '能源',
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/酿造.svg',
    //             name: '酿造',
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/农业.svg',
    //             name: '农业',
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/食品.svg',
    //             name: '食品',
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/水利.svg',
    //             name: '水利',
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/冶炼.svg',
    //             name: '冶炼',
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/印刷.svg',
    //             name: '印刷',
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/productDetail/制药.svg',
    //             name: '制药',
    //         },
    //     ],
    //     ysList: [
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/1报警.svg',
    //             name: '报警功能',
    //             title: "运行过程中发生异常系统自动报警",
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/3反控.svg',
    //             name: '反控功能',
    //             title: "在极端环境中可以远程控制设备减少运维人员远赴现场次数",
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/2掉电.svg',
    //             name: '掉电恢复后自动工作',
    //             title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/8整点.svg',
    //             name: '反控功能',
    //             title: "运行过程中发生异常系统自动报警",
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
    //             name: '掉电恢复后自动工作',
    //             title: "恢复通电后设备自动接电智能运行保障监测工作的连续性",
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
    //             name: '整点、间隔和外部控制测量',
    //             title: "实时监测、留样、分析数据，高效安全",
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/5故障.svg',
    //             name: '故障和缺试剂提示',
    //             title: " 设备突发故障系统将通过平台、小程序、短信等方式发出提示并停止工作，并设置试剂不足提示",
    //         },
    //         {
    //             imge: 'http://www.fengxinghuanbao.com:7599/images/xinruipeng/img/product/6清洗.svg',
    //             name: '自动清洗功能',
    //             title: " 自动清洗、一键式清洗",
    //         },
    //     ],
    // },
]

const groupedObjects = productList.reduce((acc, obj) => {
    if (!acc[obj.type]) {
        acc[obj.type] = [];
    }
    acc[obj.type].push(obj);
    return acc;
}, {});

const coreProducts = Object.keys(groupedObjects).map(type => {
    return groupedObjects[type][0];
});

// console.log(coreProducts);

const types = productList.map(p => ({ title: p.title, type: p.type }))
const typeArr = [...new Set(types.map(JSON.stringify))].map(JSON.parse)

const productData = {
    productList,
    coreProducts,
    typeArr,
}

export default productData